import styled from 'styled-components';
import NavBar3 from 'dc/NavBar3';

export const NavBar = styled(NavBar3)`
  width: 100%;
  position: absolute;
  top: 0;
`;
